(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/draws-redux/assets/javascripts/services/get-related-draws.js') >= 0) return;  svs.modules.push('/components/sport/draws-redux/assets/javascripts/services/get-related-draws.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
let products;
let normalizeDrawsLite;
let normalizeFundsLite;
if (svs.isServer) {
  const trinidad = require('trinidad-core').core;
  products = trinidad.components.require('utils', 'products');
  normalizeDrawsLite = require('../normalize-draws-lite.es6');
  normalizeFundsLite = require('../normalize-funds-lite.es6');
} else {
  products = svs.utils.products;
  normalizeDrawsLite = svs.components.sport.drawsRedux.normalizeDrawsLite;
  normalizeFundsLite = svs.components.sport.drawsRedux.normalizeFundsLite;
}
const fetchRelatedDraws = fetcher => req => async _ref => {
  let {
    relatedProductId,
    productId,
    drawNumber,
    type
  } = _ref;
  const itsProductId = products.getSpecificDrawName(relatedProductId);
  const params = new URLSearchParams([['ctx', "draw_".concat(itsProductId)], ['andfilter', ['payload.draw.drawState;Open'].join(',')], ['includes', ['payload.draw.regCloseTime', 'payload.draw.drawComment', 'payload.draw.drawNumber'].join(',')], ['sort', 'payload.draw.regCloseTime']]);
  const jackpotPath = '/draw/1/jackpots';
  const relatedDrawPath = "/search/1/query?".concat(params);
  const [drawData, jackpotData] = await fetcher(relatedDrawPath, jackpotPath, req);
  const Funds = normalizeFundsLite(drawData.result, jackpotData.jackpots ? jackpotData.jackpots : [], relatedProductId);
  const normalizedDraws = normalizeDrawsLite(drawData.result, relatedProductId, productId, drawNumber, type);
  return _objectSpread(_objectSpread({}, normalizedDraws), {}, {
    Funds
  });
};
if (svs.isServer) {
  const trinidad = require('trinidad-core').core;
  const fetchJackpots = async (jackpotPath, req) => {
    try {
      const jackpotResponse = await trinidad.jupiter.callAsync({
        method: 'GET',
        path: jackpotPath,
        req
      });
      return jackpotResponse;
    } catch (_unused) {
      return [];
    }
  };
  const fetchDraws = async (drawsPath, req) => {
    const drawResponse = await trinidad.jupiter.callAsync({
      method: 'GET',
      path: drawsPath,
      req
    });
    return drawResponse;
  };
  const fetcher = async (drawPath, jackpotPath, req) => {
    const [draws, jackpots] = await Promise.all([fetchDraws(drawPath, req), fetchJackpots(jackpotPath, req)]);
    return [draws, jackpots];
  };
  module.exports = fetchRelatedDraws(fetcher);
} else {
  const {
    jupiterFetch
  } = svs.core;
  const fetcher = async (drawPath, jackpotPath) => {
    const [drawResponse, jackpotResponse] = await Promise.all([jupiterFetch.fetch(drawPath, {
      method: 'GET'
    }), jupiterFetch.fetch(jackpotPath, {
      method: 'GET'
    })]);
    const drawData = await drawResponse.json();
    const jackpotData = await jackpotResponse.json();
    if (!drawResponse.ok) {
      throw drawData;
    }
    return [drawData, jackpotData];
  };
  setGlobal('svs.components.sport.drawsRedux.fetchRelatedDraws', fetchRelatedDraws(fetcher)());
}

 })(window);